import InfectedModal from "./InfectedModal"

export default InfectedModal
